<div class="message-info-root">
    <!-- column -->
    <div class="message-info-col">
        <mat-card appearance="outlined">
            <mat-card-content>
                <p>message-info works!</p>
            </mat-card-content>
        </mat-card>
    </div>
    <!-- column -->
</div>